<template>
  <div>
    <v-tabs color="secondary" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab @click="way='money'">&nbsp; &nbsp;INSTANT AEPS</v-tab>
      <v-tab @click="way='report'">&nbsp; &nbsp;AEPS-Transation Report</v-tab>
      <v-tab @click="way='report2'">&nbsp; &nbsp;BBPS Transaction Report</v-tab>
    </v-tabs>
    <div v-show="way === 'money'" class="width:100px;margin:0 auto">
      <v-btn flat @click="getUrl('aeps')" class="primary">AEPS</v-btn>
      <v-btn flat @click="getUrl('bbps')" class="primary">BBPS</v-btn>
      <v-btn flat @click="getUrl('dmr')" class="primary">DMR</v-btn>
    </div>
    <DMRReport2 v-show="way === 'report2'"></DMRReport2>
    <div v-show="way === 'report'">
      <v-card style="width:100%;padding:10px;">
        <v-layout row wrap style="height:40px;">
          <v-flex xs12 style="padding-top:8px">
            <v-btn class="success searchbtn" @click="fetchstatement">Search</v-btn>
            <!-- <input type="number"  class="search" v-model="mobile" placeholder="Enter Number"> -->
            <v-menu
              :close-on-content-click="false"
              v-model="menu2"
              lazy
              transition="scale-transition"
              offset-y
              style="float:right"
            >
              <input
                type="text"
                slot="activator"
                v-model="date2"
                readonly
                class="search"
                placeholder="To Date"
              />
              <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
            </v-menu>
            <v-menu
              :close-on-content-click="false"
              v-model="menu1"
              lazy
              transition="scale-transition"
              offset-y
              style="float:right"
            >
              <input
                type="text"
                slot="activator"
                v-model="date1"
                readonly
                class="search"
                placeholder="From Date"
              />
              <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-layout row wrap>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-card>
      <v-data-table :headers="headers" :items="statementlist" :search="search">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.autono }}</td>
          <td>{{ props.item.username }}</td>
          <td>{{ props.item.request_id }}</td>
          <td>{{ props.item.amount }}</td>
          <td>
            <v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn>
          </td>
          <td>{{ props.item.panno }}</td>
          <td>{{ props.item.mode}}</td>
          <td>{{ props.item.sub_type }}</td>
          <td>
            <v-btn @click="getsummary(props.item)" small color="primary">View</v-btn>
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait
            <v-progress-linear indeterminate color="white" class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="viewstatus" width="400">
        <v-card>
          <v-card-title style="height:40px">
            <span class="body-2">Summary of your Order</span>
          </v-card-title>
          <v-card-text style="padding-top:0px">
            <v-layout row wrap v-for="(item,key) in summary" :key="key">
              <v-flex xs6>
                <v-card-text class="px-0">{{key}}</v-card-text>
              </v-flex>
              <v-flex xs6>
                <v-card-text class="px-0">{{item}}</v-card-text>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="panupdate" width="400">
        <v-card>
          <v-card-title style="height:40px">
            <span class="title">Pan Details</span>
          </v-card-title>
          <v-card-text style="padding-top:0px">
            <v-text-field v-model="pan" placeholder="PAN Number" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat color="red" @click="panupdate = false;">Cancel</v-btn>
            <v-btn flat color="green" @click="update()">update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import MoneyTransfer from "../ezpay/MoneyTransfer";
import DMRReport from "../ezpay/DMRReport";
import DMRReport2 from "../instapay/DMRReport2";
import axios from "axios";
export default {
  data() {
    return {
      way: "money",
      headers: [
        { text: "Auto No", value: "autono", align: "left" },
        { text: "Name", value: "username" },
        { text: "Request ID", value: "request_id" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        { text: "Panno", value: "panno" },
        { text: "Mode", value: "mode" },
        { text: "Type", value: "sub_type" },
        { text: "Action", value: "action" }
      ],
      modal: false,
      date1: "",
      menu1: false,
      date2: "",
      menu2: false,
      mobile: "",
      dialog: false,
      viewstatus: false,
      statementlist: [],
      modal: false,
      search: "",
      summary: {},
      url: "",
      panupdate: false,
      pan: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    aepsurl() {
      return this.$store.getters.aepsurl;
    },
    aepshistory() {
      return this.$store.getters.aepshistory;
    },
    aepsenable() {
      return this.$store.getters.aepsenable;
    }
  },
  watch: {
    user(value) {
      let vm = this;
      if (vm.user.length == 0) {
        this.$router.push("/account");
      }
    }
  },

  components: {
    MoneyTransfer,
    DMRReport,
    DMRReport2
  },
  methods: {
    update() {
      let vm = this;
      if (vm.pan === "")
        return vm.notification("warning", "Pan Number Required!");
      let user = vm.user;
      let mobile = vm.user.phone;
//      mobile = "7202045500";
      let password = vm.user.password;
//      password = "PSsSmt";
      let auth = vm.user.authkey;
 //     auth = "5e2778c2-d8ca-4470-bff2-9f2e8259d22a";
      let url =
        vm.$store.getters.aepspan +
        "Update_PanNo?MobileNo=" +
        mobile +
        "&Password=" +
        password +
        "&AuthKey=" +
        auth +
        "&Source=json&PanNo=" +
        vm.pan;
      vm.dialog = true;
      axios
        .get(url)
        .then(res => {
          let data = res.data;
          vm.dialog = false;
          if (data.Status === "False") {
            if (data.Message === "PanNo Already Exist.") {
              vm.panupdate = false;
              window.open(vm.url, "_blank");
            } else {
              vm.notification("error", data.Message);
            }
          } else {
            vm.panupdate = false;
            window.open(vm.url, "_blank");
          }
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    },
    getUrl(name) {
      let vm = this;
      let user = vm.user;
      let mobile = vm.user.phone;
      let password = vm.user.password;
      let auth = vm.user.authkey;
      let url =
        vm.$store.getters.aepspan +
        "Check_PanNo?MobileNo=" +
        mobile +
        "&Password=" +
        password +
        "&AuthKey=" +
        auth +
        "&Source=json";
      let openurl =
        this.aepsurl +
        name +
        ".html?MobileNo=" +
        user.phone +
        "&Password=" +
        user.password +
        "&AuthKey=" +
        user.authkey +
        "&Source=json";
      vm.url = openurl;
      vm.dialog = true;
      axios
        .get(url)
        .then(res => {
          let data = res.data;
          vm.dialog = false;
          if (data.Message === "Invalid MobileNo Or Password.") {
            vm.notification("error", data.Message);
            return;
          }
          if (data.Status === "True") {
            if (
              data.Message.trim() === "*" ||
              data.Message.trim() === "NA" ||
              data.Message.trim() === ""
            ) {
              vm.panupdate = true;
              return;
            }
            window.open(openurl, "_blank");
            return;
          }
          vm.notification("error", data.Message);
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    },
    checkstatus(status) {
      status = status.toLowerCase();
      if (status == "success") return "success";
      if (status == "pending") return "grey";
      if (status == "inprocess") return "warning";
      if (status == "failed") return "error";
      return "primary";
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    pushstatement(value) {
      let vm = this;
      vm.statementlist = [];
      for (let i = 0; i < value.length; i++) {
        let doc = value[i];
        let time = doc.date_time.replace("/Date(", "").replace(")/", "");
        vm.statementlist.push({
          amount: doc.amount,
          orderid: doc.rechargeid,
          mobile: doc.transfer_mobile_no,
          time: time,
          name: doc.name,
          remark: doc.remark,
          status: doc.status,
          bank_txtid: doc.bank_txid,
          tid: doc.transaction_id
        });
      }
    },
    getsummary(doc) {
      let vm = this;
      vm.viewstatus = true;
      vm.summary = doc;
    },
    fetchstatement() {
      let vm = this;
      let mobile = vm.user.phone;
      let password = vm.user.password;
      let auth = vm.user.authkey;
      let fromdate = vm.date1;
      let todate = vm.date2;
      let url =
        vm.aepshistory +
        "AEPS_Transaction_History?MobileNo=" +
        mobile +
        "&Password=" +
        password +
        "&AuthKey=" +
        auth +
        "&Source=json&FromDate=" +
        fromdate +
        "&ToDate=" +
        todate;
      vm.dialog = true;
      axios
        .get(url)
        .then(res => {
          if (res.data) {
            vm.statementlist = res.data;
          }
          vm.dialog = false;
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    }
  },
  mounted() {
    let vm = this;
    if (vm.user.length == 0) {
      this.$router.push("/account");
      return;
    }
    if (!vm.aepsenable) {
      this.$router.push("/account");
      return;
    }
    vm.fetchstatement();
  }
};
</script>

<style scoped>
.search {
  width: 150px;
  float: right;
  height: 34px;
  background: white;
  border: 1px solid lightgray;
  outline: none;
  margin-left: 20px;
  padding-left: 10px;
  font-size: 1em;
}
.searchbtn {
  margin-right: 15px;
  height: 34px;
  margin-left: 20px;
  float: right;
  margin-top: 0px;
}
</style>
